import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const CounsellingSessionVistas = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const [selectedYear, setSelectedYear] = useState("advertisementsyr2024");
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".vistasHeader");
      if (window.scrollY > 50) {
        header?.classList.add("smallHeader");
      } else {
        header?.classList.remove("smallHeader");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  var settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToScroll: 1,
  };
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };
  return (
    <>
      <div className="vistasHeader">
        <div className="vistas-logo">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas-logo.png"
            className="img-fluid"
            alt="Lotus Valley School, Gurgaon"
          />
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? "✖" : "☰"}
        </div>

        <ul className={`vistas-menu ${menuOpen ? "open" : ""}`}>
          <li>
            <Link to="/vistas">Introduction</Link>
          </li>
          <li>
            <Link to="/counselling-session-vistas">Counselling Session</Link>
          </li>
          <li>
            <Link to="/upcomingevt-vistas">Upcoming Events</Link>
          </li>
          {/* <li>
            <Link to="/update-vistas">Updates</Link>
          </li>
          <li>
            <Link to="/spotlight-vistas">Spotlight</Link>
          </li> */}
          <li>
            <Link to="/connect-vistas">Connect with Us</Link>
          </li>
        </ul>
      </div>
      <div className="slider-vistas">
        <Slider {...settings}>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas1.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas2.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />
          </div>
          {/* <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas3.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />
          </div> */}
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas4.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas5.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />
          </div>
          {/* <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas6.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />
          </div> */}
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas7.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas8.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />
          </div>
        </Slider>
      </div>
      <div className="padding-wid vistas_p">
        <div className="container">
          <div className="accordion" id="accordionExamples">
            <div className="accordion-item">
  <h2 className="accordion-header" id="headingTwenty">
    <button
      className="accordion-button"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#collapseTwenty"
      aria-expanded="true"
      aria-controls="collapseTwenty"
    >
      Geo spatial Technology
    </button>
  </h2>

  <div
    id="collapseTwenty"
    className="accordion-collapse collapse show"
    aria-labelledby="headingTwenty"
    data-bs-parent="#accordionExamples"
  >
    <div className="accordion-body">
      <p>
        Session on ‘Exploring the World Through Geospatial Technology (GIS)’
        <br /><br />

        VISTAS – The Career Counselling and University Placement Cell, Lotus Valley International School, Gurugram, organised an engaging session on Geospatial Technology and Services (GIS) for learners of Grades X, XI and XII and their parents.
The session featured Mr Adam Grodek, Faculty Member and PhD Candidate, University at Buffalo, along with Dr Kandis Pogoda, Assistant Resident Director, University at Buffalo Programs at SIM, and Ms Tricha Vatsa, Country Manager – India, SIM.The highlight was an exciting hands-on activity where learners used geospatial data to identify the most suitable location for a hospital, understanding how location intelligence, accessibility and data analysis contribute to real-world decision-making.From finding the fastest route home to predicting floods and planning smarter cities, the session showcased the fascinating applications of GIS across diverse fields and emerging career pathways. It was an enriching experience that brought technology, geography and experiential learning together!

        <br /><br />

        #VISTAS #GIS #UniversityAtBuffalo #SIMSingapore #CareerExploration
        #ExperientialLearning #LotusValleyInternationalSchool
      </p>

      <div className="row">
        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-1.jpg"
            className="img-fluid"
            alt="Geospatial Technology 1"
          />
        </div>

        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-2.jpg"
            className="img-fluid"
            alt="Geospatial Technology 2"
          />
        </div>

        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-3.jpg"
            className="img-fluid"
            alt="Geospatial Technology 3"
          />
        </div>

        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-4.jpg"
            className="img-fluid"
            alt="Geospatial Technology 4"
          />
        </div>

        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-5.jpg"
            className="img-fluid"
            alt="Geospatial Technology 5"
          />
        </div>

        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-6.jpg"
            className="img-fluid"
            alt="Geospatial Technology 6"
          />
        </div>

        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-7.jpg"
            className="img-fluid"
            alt="Geospatial Technology 7"
          />
        </div>

        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-8.jpg"
            className="img-fluid"
            alt="Geospatial Technology 8"
          />
        </div>

        <div className="col-md-3 mb-3">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Geo-9.jpg"
            className="img-fluid"
            alt="Geospatial Technology 9"
          />
        </div>
      </div>
    </div>
  </div>
</div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingEleven">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseEleven"
                  aria-expanded="true"
                  aria-controls="collapseEleven"
                >
                  Lotus Blooms – Alumni Connect Session
                </button>
              </h2>

              <div
                id="collapseEleven"
                className="accordion-collapse collapse "
                aria-labelledby="headingEleven"
                data-bs-parent="#accordionExamples"
              >
                <div className="accordion-body">
                  <p>
                    The school’s Career Counselling and University Placement
                    Cell successfully hosted an inspiring Alumni Connect session
                    featuring our distinguished alumni from IIT Delhi. Annirudha
                    Bhattacharya (B.Tech. Chemical Engineering) and Agastya
                    Trikha (Bachelor of Design) shared their academic journeys,
                    campus experiences, and admission strategies with Grade XI
                    and XII learners. Their insightful discussion highlighted
                    the realities of life at IIT Delhi, diverse career pathways,
                    and the importance of perseverance and informed planning.
                    The interactive Q&A session enabled participants to seek
                    guidance on competitive exams, higher education, and career
                    aspirations. The session motivated learners to dream
                    ambitiously, prepare strategically, and pursue excellence
                    with confidence.
                    <br />
                    #LotusBlooms #AlumniConnect #IITDelhi #CareerCounselling
                    #UniversityPlacement #VISTAS #LotusValleyInternationalSchool
                    #LVISG #FutureReady #HigherEducation #StudentSuccess
                    #CareerGuidance #MentorshipMatters #LearningBeyondClassrooms
                    #AspireAchieveExcel #InspiringMinds #AlumniInspiration
                    #FutureLeaders #DreamBig #EducationForLife
                    #AcademicExcellence #CompetitiveExams #Engineering
                    #DesignEducation #Innovation #Leadership #SchoolToSuccess
                    #BuildingFutures
                  </p>
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-1.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-2.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 2"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-3.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 3"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-4.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 4"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-5.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 5"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-6.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 6"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-7.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 7"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-8.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-9.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-10.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-11.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-12.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-13.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-14.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/al-15.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="headingNine">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseNine"
                  aria-expanded="true"
                  aria-controls="collapseNine"
                >
                  Masterclass on Inside the Mind: A Beginner's Guide to
                  Psychology
                </button>
              </h2>

              <div
                id="collapseNine"
                className="accordion-collapse collapse "
                aria-labelledby="headingNine"
                data-bs-parent="#accordionExamples"
              >
                <div className="accordion-body">
                  <p>
                    Lotus Valley International School, Gurugram, had the
                    privilege of hosting an engaging masterclass by
                    <b> Prof. Kristen Pammer,</b> Head of the Melbourne School
                    of Psychological Sciences, The University of Melbourne,
                    Australia.
                    <br />
                    The interactive session introduced students to psychology as
                    the scientific study of the human mind and behaviour.
                    Through fascinating brain facts and the renowned Invisible
                    Gorilla experiment, Prof. Pammer demonstrated the concept of
                    <b>inattentional blindness</b> and highlighted how our minds
                    can overlook obvious information when focused elsewhere.
                    <br />
                    Students also discovered how psychology influences everyday
                    life—from road safety and technology to business, climate
                    change, and mental health. The session sparked curiosity,
                    critical thinking, and a deeper appreciation of the science
                    behind human behaviour.
                  </p>
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-1.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-2.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 2"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-3.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 3"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-4.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 4"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-5.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 5"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-6.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 6"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-7.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 7"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-8.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-9.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-10.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-11.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-12.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-12.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-14.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-15.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-16.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-17.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-18.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-19.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/master-20.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTen">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTen"
                  aria-expanded="false"
                  aria-controls="collapseTen"
                >
                  Guest Lecture on From Classroom to Boardroom: Journey to
                  Becoming a Company Secretary
                </button>
              </h2>

              <div
                id="collapseTen"
                className="accordion-collapse collapse"
                aria-labelledby="headingTen"
                data-bs-parent="#accordionExamples"
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Journey-1.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Journey-2.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Journey-3.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Journey-4.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Journey-5.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Journey-6.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Journey-7.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Journey-8.jpeg"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ITEM 1 (OPEN BY DEFAULT) */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Alumni Interaction Session with Ms. Gauri Sharma
                </button>
              </h2>

              <div
                id="collapseOne"
                className="accordion-collapse collapse "
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExamples"
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/new-1.png"
                        className="img-fluid"
                        alt="Lotus Valley 1"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-1.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 2"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-2.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 3"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ITEM 2 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Lotus Blooms: Alumni Interaction Session with Arav Mathur,
                  Ryan Puri and Dhruv Kumar
                </button>
              </h2>

              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExamples"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-4.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 4"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-5.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 5"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-6.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 6"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-7.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 7"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-8.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 8"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ITEM 3 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Alumni Career Talk on Design by Aaira Katoch
                </button>
              </h2>

              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExamples"
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-9.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 9"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-10.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 10"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-11.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 11"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-12.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 11"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ITEM 4 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  Lotus Blooms Alumni Interaction Session for Science Students
                  by Mridul Seshadri, BITS Pilani; Ramdas, Indian Statistical
                  Institute, Bengaluru; and Vrishank Singh, Arizona State
                  University
                </button>
              </h2>

              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#accordionExamples"
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-13.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 12"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-14.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 13"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-15.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 14"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-16.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 15"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* irem--5 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  Alumni Session at Lotus Valley International School, Gurugram
                  by Dhanishta Kaul, currently pursuing BA (Hons) Psychology at
                  Lady Shri Ram College for Women, University of Delhi; Sana
                  Mehta, pursuing BSc LLB in Forensic Science and Criminology at
                  The West Bengal National University of Juridical Sciences,
                  Kolkata; and Kaina Malik, pursuing BA Psychology at Duke
                  University, UK.
                </button>
              </h2>

              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#accordionExamples"
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-16.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 12"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-18.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 13"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lotus-19.jpg"
                        className="img-fluid"
                        alt="Lotus Valley 14"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="w-100 position-relative ">
            <div className="mb-4 h-100">
              <select
                className="advertisementsselect-press float-end"
                value={selectedYear}
                onChange={handleYearChange}
              >
                <option value="advertisementsyr2024">Year 2024-25</option>
                <option value="advertisementsyr2023">Year 2023-24</option>
              </select>
            </div>
            <div className="heading text-center d-block">
              <h1 className="mx-auto text-black mb-4 font-play">
                
                'VISTAS: Success in Sight when you Plan Right' <br />
                CAREER COUNSELLING AND UNIVERSITY PLACEMENT CELL
              </h1>
            </div>

            <div>
              <div
                className={`advertisementspress1 advertisementsyr2024`}
                style={{
                  display:
                    selectedYear === "advertisementsyr2024" ? "block" : "none",
                }}
              >
                <div className="advertisementspress1 display advertisementsyr2024">
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play  mb-4">
                            Multi-Country Education Fair 2025
                            <a
                              href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/Multi-Country-Education-Fair-2025.pdf"
                              target="_blank"
                              className="primary-color"
                            >
                              click here
                            </a>
                            <a></a>
                          </h4>
                          <a></a>
                        </div>
                        <a></a>
                      </section>
                      <a></a>
                      <section>
                        <a></a>

                        <div className="heading text-left">
                          <h4 className="mx-auto font-play  mb-4">
                            Orientation Session on New York University
                            Admissions
                            <a
                              href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/Orientation-Session-on-New-York-University-Admissions.pdf"
                              target="_blank"
                              className="primary-color"
                            >
                              click here
                            </a>
                            <a></a>
                          </h4>
                          <a></a>
                        </div>
                        <a></a>
                      </section>
                      <a></a>
                      <section>
                        <a></a>

                        <div className="heading text-left">
                          <h4 className="mx-auto font-play  mb-4">
                            Lotus Blooms Alumni Connect programme
                            <a
                              href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/Lotus-Blooms-Alumni-Connect-programme.pdf"
                              target="_blank"
                              className="primary-color"
                            >
                              click here
                            </a>
                            <a></a>
                          </h4>
                          <a></a>
                        </div>
                        <a></a>
                      </section>
                      <a></a>
                      <section>
                        <a></a>
                        <div className="heading text-left">
                          <a></a>
                          <h4 className="mx-auto font-play mb-4">
                            <a>
                              Master Class on ‘The Creator Experience: An
                              Insider's Guide to Content Creation’
                            </a>
                            <a
                              href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/Master-Class-on-The-Creator-Experience-An-insiders-Guide -to-Content-Creation.pdf"
                              target="_blank"
                              className="primary-color"
                            >
                              click here
                            </a>
                            <a></a>
                          </h4>
                          <a></a>
                        </div>
                        <a></a>
                      </section>
                      <a></a>
                      <section>
                        <a></a>
                        <div className="heading text-left">
                          <a></a>
                          <h4 className="mx-auto font-play mb-4">
                            <a>
                              In-house Career Counselling Session for Grade IX
                              in July 2024
                            </a>
                            <a
                              href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/Report-IX.pdf"
                              target="_blank"
                              className="primary-color"
                            >
                              click here
                            </a>
                            <a></a>
                          </h4>
                          <a></a>
                        </div>
                        <a></a>
                      </section>
                      <a>
                        <section>
                          <div className="heading text-left">
                            <h4 className="mx-auto font-play mb-4">
                              Pathways Unveiled: Global University Education
                              Fair 2024 Chronicles
                            </h4>
                          </div>
                        </section>
                        <section>
                          <div className="text-left">
                            <p>
                              The Global University Education Fair 2024,
                              organized by Lotus Valley International School in
                              collaboration with Ikigaii Education Services was
                              held on Saturday, 27th April 2024, the fair
                              provided a unique platform for high school
                              students (Grades XI &amp; XII) to explore various
                              career options and interact with representatives
                              from 44 renowned universities worldwide.
                            </p>
                            <p>
                              Learners from various Delhi-NCR schools
                              enthusiastically participated in the fair,
                              engaging in meaningful conversations with
                              university representatives and seeking guidance on
                              their future academic paths. The fair concluded
                              with a sense of accomplishment and satisfaction,
                              as students departed with a clearer vision of
                              their academic paths and a renewed enthusiasm for
                              their future endeavours.
                            </p>
                          </div>
                        </section>
                      </a>
                    </div>
                  </div>

                  <div className="row justify-content-center mb-3">
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/1.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/2.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/3.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                </div>

                <div className="advertisementspress1 display advertisementsyr2024">
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play">
                            Session on 'All About CUET - The Common University
                            Entrance Test'
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            Under the patronage of our Director Principal, Ms.
                            Anita Malhotra, a session was conducted on 'All
                            About CUET - The Common University Entrance Test'
                            for Grade XI and XII learners and parents. The
                            session was conducted by Dr. Suman Kharbanda,
                            Associate Professor at Shivaji College, Delhi
                            University
                          </p>
                          <p>
                            Dr. Kharbanda eloquently commenced the session by
                            outlining the significance of CUET in undergraduate
                            admissions. She emphasized the importance of
                            understanding the structure of the CUET exam to
                            enable students to make informed choices regarding
                            programs and colleges. The session concluded with a
                            vibrant exchange of queries from both parents and
                            students.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/4.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/5.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                </div>

                <div className="saperator"></div>
                <div className="advertisementspress1 display advertisementsyr2024">
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play">
                            PARENTAL GUIDANCE:CAREER DISCUSSIONS FOR GRADES X ON
                            MARCH 12, 2024
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            Under the auspices of Vistas, the Career Counselling
                            &amp; University Placement Cell organized Parent
                            Career Counselling Sessions for Grades X. The
                            sessions were led by Mr. Abhishek Gupta for Grades X
                            who provided valuable insights into university
                            admissions and scholarships, emphasizing what
                            universities look for in candidates, including
                            interests, aptitudes, and skills. He also
                            underscored the significance of internships and
                            summer programs in relevant fields. Additionally,
                            Mr. Gupta discussed the importance of subject
                            combinations in accordance with the guidelines of
                            the National Education Policy (NEP), which broaden
                            the scope for pursuing new age careers.
                          </p>
                          <p>
                            The sessions were highly informative, prompting
                            numerous inquiries from the attending parents.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-5">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/3.jpg"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/4.jpg"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`advertisementspress1 advertisementsyr2023`}
                style={{
                  display:
                    selectedYear === "advertisementsyr2023" ? "block" : "none",
                }}
              >
                <div className="saperator"></div>
                <div className="advertisementspress1 advertisementsyr2023">
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play mb-4">
                            CAREER COUNSELLING SESSIONS FOR GRADES IX, X AND X
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            Under the auspices of The Lotus Career/College
                            Guidance Unit, 'Vistas: Success in Sight when you
                            Plan Right,' a Career Counselling Session was
                            conducted by Jitin Chawla on December 27, 2024. This
                            session was ideated by Mr. Hariharan Balagopal, the
                            Editor &amp; Founder of School Live Magazine.
                          </p>
                          <p>
                            The session began with a role play where children
                            acted as parents, and Mr. Chawla portrayed a
                            15-year-old child. This humorous act set the stage
                            with lots of laughter and provided insight into an
                            adolescent's perspective on career choices. Mr.
                            Chawla discussed various options available for
                            different subjects and highlighted the importance of
                            taking summer schools and internships.
                          </p>
                          <p>
                            The session concluded with Mr. Chawla addressing
                            numerous queries from the attendees.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/5.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-3">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/6.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                  <div className="saperator"></div>
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play mb-4">
                            CAREER GUIDANCE SESSION ON ‘DREAM CAREERS ABROAD’
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            A session titled ‘Dream Careers Abroad’ was
                            conducted by Hima Mal, Director of Ikigaii Education
                            Services, for Grade XI students on August 18,
                            2024.
                          </p>
                          <p>
                            The session aided students in enhancing their
                            profiles by emphasizing on intellectual vitality, a
                            fundamental component for profile enrichment. Hima
                            Mal's dedication to education radiated through her
                            dynamic and productive sessions. She even guided the
                            students away from pursuing the wrong paths,
                            ensuring they avoided unproductive avenues that
                            could cause them to miss out on valuable
                            opportunities.
                          </p>
                          <p>
                            She encouraged learners to align their plans with
                            core concepts and adeptly imparted guidance on
                            crafting effective profiles, ensuring the accurate
                            inclusion of information in the profile-building
                            process.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/7.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/8.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                  <div className="saperator"></div>
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play mb-4">
                            PARENT TALK AND CAREER FAIR
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            “The best way to predict the future is to create
                            it.”
                          </p>
                          <p>
                            To empower the students with the erudition to fulfil
                            their goals and help them get admission to their
                            dream universities, a talk and a career fair was
                            organized at Lotus Valley International School for
                            Grades IX to XII.
                          </p>
                          <p>
                            The session commenced with a warm welcome of the
                            resource person, Abhishek Gupta who spoke on the
                            topic - ‘Career, Admissions &amp; Scholarships: What
                            parents need to know’. Taking over the platform, he
                            captivated the learners and the parents with the
                            sheer amplitude of information regarding
                            profile-building. The talk was both inspiring &amp;
                            fruitful wherein the ideas and options widened the
                            horizons of the learners with respect to achieving
                            their desired goals.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/9.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/10.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                  <div className="saperator"></div>
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play mb-4">
                            UNLOCKING YOUR PATH TO SUCCESS: MASTERING THE ART OF
                            CRAFTING WINNING SOPS AND SEIZING SCHOLARSHIPS FOR
                            UK UNDERGRADUATE ADVENTURES
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            On October 3, 2023, an enlightening online session
                            titled ‘Unlocking Your Path to Success: Mastering
                            the Art of Crafting Winning SOPs and Seizing
                            Scholarships for UK Undergraduate Adventures’ took
                            place in the school auditorium on MS Teams. The
                            esteemed speaker for this session was Dr. Pankhuri
                            Agarwal, an illustrious alumna of SRCC College,
                            Delhi University, who currently serves as a
                            postdoctoral researcher in the School of Management
                            at the University of Bath. The session commenced
                            with Dr. Agarwal's insightful discussion on the
                            importance of crafting one's own Statement of
                            Purpose (SOP) for undergraduate program
                            applications. She emphasized the key differences
                            between a personalized SOP and the generic ones
                            often provided by agents.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/11.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/12.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                  <div className="saperator"></div>
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play mb-4">
                            SESSION ON DEDUCTIVE REASONING AND CRITICAL THINKING
                            SKILLS
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            Sessions on October 29 and 30, 2023 were conducted
                            for Grade XI students by Mr. Anand Venkatesan, an
                            alumnus of the prestigious IIM Bangalore and a
                            graduate in Engineering from VIT, Vellore, and Mr.
                            Abhishek Anand, who holds an MBA from IIM Bangalore
                            and a B.Com (Hons) from SRCC, Delhi University. The
                            sessions focused on developing critical thinking
                            skills, during which they presented
                            thought-provoking 'guestimates' to the students. It
                            was emphasized that the process of solving these
                            problems was more important than the actual answers.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/13.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/14.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                  <div className="saperator"></div>
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play mb-4">
                            CERTIFICATE OF DISTINCTION IN THE EUCLID COMPETITION
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            Learners of Grade XII (Ramdas Singh, Aarav Garg,
                            Snehal Singh, Mahir Dhamija, and Aditya Marwah)
                            brought laurels to the school by scoring in the top
                            25% of all participating students and received a
                            Certificate of Distinction in the Euclid Competition
                            conducted by The Centre for Education in Mathematics
                            and Computing, University of Waterloo, Canada.
                            School Champion, Ramdas Singh (XII-Archimedes), also
                            received a Medal.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                  <div className="saperator"></div>
                  <div className="row">
                    <div className="col-md-12 textarea">
                      <section>
                        <div className="heading text-left">
                          <h4 className="mx-auto font-play mb-4">
                            CAREER COUNSELING SESSION ON 'GET SET, GO! GEAR UP
                            FOR THE NEXT U.S. UNIVERSITY INTAKE'
                          </h4>
                        </div>
                      </section>
                      <section>
                        <div className="text-left">
                          <p>
                            "The best way to predict the future is to create
                            it." —Abraham Lincoln
                          </p>
                          <p>
                            To motivate the learners to realize their higher
                            education aspirations, Lotus Valley International
                            school in collaboration with EducationUSA, USIEF
                            organised a career counselling session 'Get Set, Go!
                            Gear up for the next U.S. University Intake' for
                            grades X &amp; XII on Thursday March 23, 2023. Ms.
                            Megha Yadav, Advisor, Education USA facilitated the
                            session with a plethora of information viable for
                            the learners to channelize their passions well in
                            time. She emphasized that one must have in-depth
                            knowledge of the choices, lest one might end-up in a
                            career that is not meant for them.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div className="row justify-content-center mb-3">
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/16.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                    <div className="col-md-4">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/17.webp"
                        className="h-100 img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/* <div className="copyright-vistas">
        © 2024 All rights reserved with Lotus Valley School, Gurgaon
      </div> */}
    </>
  );
};

export default CounsellingSessionVistas;
